import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UserRoleCheckerService } from '../services/auth/user-role-checker.service';

@Injectable()
export class AdminGuard {
  constructor(
    private readonly userRoleCheckerService: UserRoleCheckerService,
  ) { }

  canActivate(): Observable<boolean> {
    const result = this.userRoleCheckerService.isSystemAdmin()
      || this.userRoleCheckerService.isAdmin();
    return of(result);
  }
}
